import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/base/baseline.css";
import "../../styles/pages/services.css";

import "../../styles/module/collaborate.css";
import "../../styles/module/carousel.css";

import WhyUs from "../module/Why-Us";
import Analytics from "../module/Analytics-Slider";
import Collaborate from "../module/Collaborate";
import FAQs from "../module/FAQs";
import Clients from "../module/Clients";

import bg2 from "../../assets/images/img/bg-2.webp";
// import bg3 from "../../assets/images/img/bg-3.svg";
import arrow from "../../assets/images/img/downarrow.webp";

export default function DataAnalytics() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background slide-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
        >
          <img src={arrow} alt="downarrow" className="" />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section section__oferta">
          {/* <img
            className="landing__image-background-1 image-background slide-from-right"
            src={bg3}
            alt="container background"
          /> */}
          <div className="container oferta">
            <h5 className="drop-from-top" id="scroll">
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>service</font>
              </font>
            </h5>
            <div className="title drop-from-top">
              <h2 style={{ marginBottom: "30px" }}>
                Data Analytics & Insights Driving Smarter Decisions
              </h2>
            </div>
            <div className="description container__text">
              <p className="slide-from-left">
                We turn raw data into clear, actionable insights that align with
                your business objectives. By customizing analytics dashboards
                and reports, we help you track key metrics, understand user
                behavior, and uncover growth opportunities.
              </p>
              <p className="slide-from-right">
                Our approach focuses on accuracy, real-time data access, and
                meaningful visualization—empowering your team to make informed
                decisions quickly. Whether you need deep analysis of customer
                trends or performance monitoring, our tailored solutions unlock
                the full potential of your data.
              </p>
            </div>
          </div>
        </div>
        <WhyUs hideBackgroundImage={true} />
        <Analytics />
        <Collaborate />
        <FAQs />

        <Clients />
      </div>
    </>
  );
}
